import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=356d29a1&scoped=true&"
import script from "./Order.vue?vue&type=script&lang=js&"
export * from "./Order.vue?vue&type=script&lang=js&"
import style0 from "./Order.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Order.vue?vue&type=style&index=1&id=356d29a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356d29a1",
  null
  
)

export default component.exports